import styled, { css } from 'styled-components'

import { BREAKPOINTS } from 'resources'

export const InnerContainer = styled.div`
  width: 100%;
  max-width: 1100px;
  position: relative;
`

const FillScreenStyle = css`
  flex: 1;

  ${InnerContainer} {
    flex: 1;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: ${({ removePaddingTop }) => (removePaddingTop ? 0 : 40)}px;
  padding-bottom: ${({ removePaddingBottom }) => (removePaddingBottom ? 0 : 40)}px;
  padding-right: 20px;
  padding-left: 20px;

  ${({ fillScreen }) => fillScreen && FillScreenStyle}

  @media (min-width: ${BREAKPOINTS.md}) {
    padding-right: 50px;
    padding-left: 50px;
  }
`
